import React from 'react';
import { connect } from 'react-redux';
import { FormSection, formValueSelector } from 'redux-form';
import styled, { css } from 'styled-components';

import If from 'components/Shared/If';
import { HelpButton } from 'components/Shared/Buttons';
import { Checkbox, Select, MultiSelect, LABEL_POSITION } from 'components/Shared/Forms';
import { controlPositions, mapTypes, mapTypeStyles } from 'modules/advancedSettings';
import Collapse from 'components/Shared/Collapse';
import { SCAFFOLDING, SETTINGS_INPUTS, INPUT_TOGGLES } from 'theme';

const opts = (x) => Object.keys(x).map((y) => ({ label: y, value: y }));
const positionOptions = opts(controlPositions);
const styleOptions = opts(mapTypeStyles);
const typeOptions = opts(mapTypes);

const StyledFormSection = styled(FormSection)`
    margin-left: -${SETTINGS_INPUTS.PADDING.X};
    margin-right: -${SETTINGS_INPUTS.PADDING.X};
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SETTINGS_INPUTS.PADDING.X} ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    padding-left: ${`calc(${parseInt(SETTINGS_INPUTS.PADDING.X, 10) + 10}px + ${INPUT_TOGGLES.WIDTH})`};
    background-color: ${SETTINGS_INPUTS.BG.SUB};

    & + & {
        margin-top: 1px;
    }
`;

const SectionHeader = styled.div`
    margin-bottom: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
    font-weight: 700;
`;

const SectionTitle = styled.span`
    vertical-align: middle;
`;

const StyledHelpButton = styled(HelpButton)`
    margin-left: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
`;

const StyledInput = css`
    padding-top: ${SETTINGS_INPUTS.PADDING.Y};
    padding-bottom: ${SETTINGS_INPUTS.PADDING.Y};
`;

const StyledCheckbox = styled(Checkbox)`
    ${StyledInput}
`;

const StyledSelect = styled(Select)`
    ${StyledInput}

    label {
        flex: 0 0 auto;
        width: 4em;
    }

    .Select {
        min-width: 15em;
    }
`;

const StyledMultiSelect = StyledSelect.withComponent(MultiSelect);

const CustomControlSection = ({ name, title, label, help, enabled }) => {
    return (
        <StyledFormSection name={name}>
            <SectionHeader>
                <SectionTitle>{title}</SectionTitle>
                {help && <StyledHelpButton value={help} />}
            </SectionHeader>
            <StyledCheckbox inline toggleSwitch name="enabled" label={label} labelPosition={LABEL_POSITION.LEFT} />
            <Collapse isOpened={!!enabled}>
                <If statement={name !== 'scale'}>
                    <StyledSelect
                        name="position"
                        label="Position"
                        labelPosition={LABEL_POSITION.LEFT}
                        options={positionOptions}
                    />
                </If>
                <If statement={name === 'mapType'}>
                    <StyledSelect
                        name="style"
                        label="Style"
                        labelPosition={LABEL_POSITION.LEFT}
                        options={styleOptions}
                    />
                </If>
                <If statement={name === 'mapType'}>
                    <StyledMultiSelect
                        name="types"
                        label="Type"
                        labelPosition={LABEL_POSITION.LEFT}
                        options={typeOptions}
                    />
                </If>
            </Collapse>
        </StyledFormSection>
    );
};

const selector = formValueSelector('advanced-form');

const mapStateToProps = (state, ownProps) => ({
    enabled: selector(state, `controls.custom.${ownProps.name}.enabled`),
});

export default connect(mapStateToProps)(CustomControlSection);
